import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import {
  ListProject,
  CreateTaskExpenses,
  UpdateTaskExpenses,
  ListTaskExpenses,
  apiClient,
  Createbuget,
  Updatebuget,
  Listbudget,
  ListProjectDetail,
  createTodo,
  ProjectDiscussionList,
  ProjectDiscussionCreate,
  BASE_URL,
  ListTodoByProject,
  updateTodo,
  deleteTodo,
  CreateTaskTrack,
  Deletebuget,
  DeleteTaskExpense,
  MediaUrl,
} from "../../../Utility/Api"; // Import your API functions
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ProjectForm from "./form";
import { useLocation } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { TaskFormProject } from "./Modal/TaskFormProject";
import {
  handleImageError,
  handleUserImageError,
  shop_id,
} from "../../../Utility/function";
import "./projectview.css";
import { WarehouseContext } from "../../../Utility/UserContext";
import Transaction from "./Transaction";
import { Deletemodel } from "../../Common/Functions";
ChartJS.register(ArcElement, Tooltip, Legend);

export const PROJECT_STATUS = [
  { id: "3", label: "Yet To Start" },
  { id: "0", label: "InProgress" },
  { id: "1", label: "Completed" },
  { id: "2", label: "Cancelled" },
];

const getBackgroundColor = (status) => {
  switch (status) {
    case "0":
      return "#B2E0EE"; // In Progress
    case "1":
      return "#CCF894"; // Completed
    case "2":
      return "#FBE7E7"; // Cancelled
    case "3":
      return "#EDEDED"; // Yet to start
    default:
      return "white"; // Default background
  }
};

const Projectview = ({ customers, pettyCash, remaining }) => {
  const location = useLocation();
  var value = location.state?.value;
  const { showLoader, hideLoader, UserItem } = useContext(WarehouseContext);
  const [user, setuser] = useState(UserItem);
  const [showModal, setShowModal] = useState(false);
  const [Project, setProject] = useState([]);
  const [projectData, setProjectData] = useState();
  const [employeeData, setEmployeeData] = useState();
  const [managerData, setManagerData] = useState();
  const [selectedData, setSelectedData] = useState(null);
  const percentage = Math.min(
    Math.round(
      ((projectData?.paid_amount || 0) / (projectData?.estimation_amount || 1)) * 100
    ),
    100
  );
  const [selectedtab, setSelectedtab] = useState(0);
  const [transtab, setTranstab] = useState(0);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [show, setShow] = useState(false);
  const [listdata, setlistdata] = useState([]);
  const [todo, settodo] = useState([]);
  const [deleteID, setDeleteID] = useState("");
  const [deletemodel, showDeletemodel] = useState(false);

  useEffect(() => {
    if (value?.id) {
      fetchProjectDetail(value?.id);
      fetchProjectDiscussion(value?.id);
      fetchTodo();
      fetchBudgets();
    } else {
      fetchProject();
      fetchTasks();
      fetchTodo();
    }
  }, [value]);

  const fetchProjectDetail = async (ID) => {
    try {
      const response = await ListProjectDetail(ID || value?.id);
      console.log("Project Detail", response.data.data);

      if (response.data && response.data.data) {
        setProjectData(response.data.data?.project_data);
        setEmployeeData(response.data.data?.employee_data);
        setManagerData(response.data.data?.managers_data);
        fetchTodo();
        console.log("Project Detail", response.data.data);
      } else {
        toast.error("No Detail found.");
      }
    } catch (error) {
      console.error("Error fetching units:", error);
      // toast.error("Error fetching units");
    }
  };

  const fetchProject = async () => {
    try {
      const response = await ListProject();
      if (response.data && response.data.data) {
        setProject(response.data.data);
        console.log("project", response.data.data);
      } else {
        toast.error("No units found.");
      }
    } catch (error) {
      console.error("Error fetching units:", error);
      // toast.error("Error fetching units");
    }
  };


  // Data for Pie Chart
  const chartData = {
    labels: ["Remaining Hours", "Spent Hours"],
    datasets: [
      {
        data: [projectData?.total_hours - projectData?.total_sum_hours, projectData?.total_sum_hours],
        backgroundColor: ["#3B82F6", "#FACC15"],
      },
    ],
  };

  const [tasks, setTasks] = useState([]);
  const [editExpense, setEditExpense] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    amount: "",
    media_urls: null,
    type: 1, // Default type = 1
  });

  const fetchTasks = async () => {
    try {
      const response = await ListTaskExpenses(1, value?.id);
      if (response.data && response.data.data) {
        setlistdata(response.data.data);
      } else {
        toast.error("No tasks found.");
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      // toast.error("Error fetching tasks");
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    if (e.target.name === "media_urls") {
      setFormData({ ...formData, media_urls: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const ExpeseshandleEdit = (task) => {
    setEditExpense(task);
    setFormData(task);
    setShow(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.title ||
      !formData.description ||
      !formData.amount ||
      !formData.type
    ) {
      toast.error("All fields are required");
      return;
    }

    // Create FormData to send files
    const payload = new FormData();
    payload.append("title", formData.title);
    payload.append("description", formData.description);
    payload.append("amount", formData.amount);
    if (formData.media_urls) {
      payload.append("media_urls", formData.media_urls);
    }
    payload.append("type", formData.type);
    payload.append("project_id", value.id);
    payload.append("emp_id", user.user_id);

    try {
      let response;
      if (editExpense) {
        response = await UpdateTaskExpenses(editExpense.id, formData);
        toast.success(response?.message || "Expenses updated successfully");
      } else {
        await CreateTaskExpenses(payload);
        toast.success("Expenses added successfully");
      }
      fetchTasks();
      handleClear();
    } catch (error) {
      console.error("Error creating task:", error);
      toast.error("Failed to add task");
    }
  };

  const handleClear = () => {
    setEditExpense(null);
    setFormData({
      title: "",
      description: "",
      amount: "",
      invoice: null,
      type: 1,
    });
    setShow(false);
  };

  const [show1, setShow1] = useState(false);
  const [budgetList, setBudgetList] = useState([]);
  const [budgetData, setBudgetData] = useState({
    date: new Date().toISOString().split("T")[0],
    from_date: "",
    to_date: "",
    project_id: value?.id || "", // Safe fallback
    remark: "",
    title: "",
    total_cost: "",
    total_hours: "",
  });
  const [editBudget, setEditBudget] = useState(null); // Track editing budget

  const fetchBudgets = async () => {
    try {
      const response = await Listbudget(value?.id);
      if (response.data && response.data.data) {
        setBudgetList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching budgets:", error);
    }
  };

  const handleChange1 = (e) => {
    setBudgetData({ ...budgetData, [e.target.name]: e.target.value });
  };

  const handleEdit = (budget) => {
    setEditBudget(budget); // Set the selected budget for editing
    setBudgetData(budget); // Pre-fill the form with the budget's existing data
    setShow1(true); // Open the modal
  };

  const handleClear1 = () => {
    setShow1(false);
    setEditBudget(null);
    setBudgetData({
      date: "",
      from_date: "",
      to_date: "",
      project_id: value?.id || "",
      remark: "",
      title: "",
      total_cost: "",
      total_hours: "",
    });
  };

  const handleSubmit1 = async () => {
    if (
      !budgetData.date ||
      !budgetData.from_date ||
      !budgetData.to_date ||
      !budgetData.remark ||
      !budgetData.title ||
      !budgetData.total_cost ||
      !budgetData.total_hours
    ) {
      toast.error("All fields are required");
      return;
    }
    try {
      let response;
      if (editBudget) {
        response = await Updatebuget(editBudget.id, budgetData);
        toast.success(response?.message || "Budget updated successfully");
      } else {
        response = await Createbuget(budgetData);
        toast.success(response?.message || "Budget created successfully");
      }

      fetchBudgets(); // Refresh the list
      handleClear1(); // Reset form
    } catch (error) {
      console.error("Error saving budget:", error);
      toast.error(error?.response?.data?.message || "Failed to create budget"); // Show error message if available
    }
  };

  const [showTaskModal, setShowTaskModal] = useState(false);
  const [showTimeModal, setShowTimeModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState();
  const [start_time, setStartTime] = useState("");
  const [end_time, setEndTime] = useState("");


  const updateTodoStatus = async (todo_id, status) => {
    showLoader();
    try {
      const payload = {
        status: status,
      };

      if (todo_id) {
        await updateTodo(todo_id, payload);
        toast.success("Toto status updated successfully");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.message || "An unexpected error occurred");
    } finally {
      hideLoader();
      fetchTodo();
    }
  };

  const handleClearTime = () => {
    setShowTimeModal(false);
    setSelectedTask(null);
    setStartTime("");
    setEndTime("");
  };

  const handleOpenTimeModal = (task) => {
    setSelectedTask({
      ...task,
      date: new Date().toISOString().split("T")[0], // default today's date
    });
    setShowTimeModal(true);
  };

  const handleSubmitTime = async () => {
    if (!selectedTask?.id) {
      toast.error("Task not selected");
      return;
    }

    if (!start_time || !end_time) {
      toast.error("Please enter both start and end time");
      return;
    }

    if (start_time >= end_time) {
      toast.error("Start time must be before end time");
      return;
    }


    var payload = {
      "emp_id": user?.user_id,
      "project_id": selectedTask?.ProjectID || "",
      "task_id": selectedTask?.id,
      "hour_rate": selectedTask?.hourly_rate || 0,
      "date": selectedTask.date,
      "start_time": `${start_time}:00`,
      "end_time": `${end_time}:00`,
      "status": "True",
      "add_status": "1"
    };

    try {
      showLoader();
      await CreateTaskTrack(payload);
      toast.success("Task time updated successfully");
      handleClearTime();
      fetchTodo();
    } catch (error) {
      console.error("Error updating task time:", error);
      toast.error("Failed to update task time");
    } finally {
      hideLoader();
    }
  };

  const fetchTodo = async () => {
    try {
      const response = await ListTodoByProject(value?.id);
      if (response?.data) {
        settodo(response.data.data);
      }
    } catch (error) {
      settodo([]);
      // toast.error("Error fetching tasks");
    }
  };

  const handleAddTask = async (taskData) => {
    try {
      const newTask = { ...taskData, project_id: value?.id, shop_id: shop_id }; // Ensure project_id is included
      await createTodo(newTask);
      fetchTasks(value?.id); // Refresh task list after adding
      setShowTaskModal(false);
      setSelectedTask();
    } catch (error) {
      console.error("Error adding task:", error);
    }
  };



  const [messages, setMessages] = useState([]); // Store messages
  const [text, setText] = useState(""); // Input message
  const [file, setFile] = useState(null); // Uploaded file
  const [caption, setCaption] = useState(""); // Caption for image
  const [loading, setLoading] = useState(false);

  const formatDate = (date, time) => {
    const dateObj = new Date(`${date}T${time}`);
    return dateObj.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  const fetchProjectDiscussion = async () => {
    try {
      const response = await ProjectDiscussionList(value?.id);
      if (response?.data) {
        const commentArrry = response?.data?.data.map((item) => ({
          id: item.id,
          username: item.employee_name,
          avatarUrl: item?.emp_image
            ? BASE_URL + "media/" + item?.emp_image
            : "./../assets/images/profile.png",
          date: formatDate(item.date, item.time),
          comment: item.remarks !== "0" ? item.remarks : `No message`,
          link:
            item.file && item.media_type == "1"
              ? BASE_URL + "media/" + item.file
              : undefined,
          image:
            item.file && item.media_type == "0"
              ? BASE_URL + "media/" + item.file
              : undefined,
        }));
        setMessages(commentArrry.reverse());
        // setMessages(response.data.data);
      }
    } catch (error) {
      // toast.error("Error fetching tasks");
    }
  };

  // Handle file selection
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };


  const isImage = (file) => {
    return file.type.startsWith("image/");
  };

  const handleSend = async () => {
    if (!text && !file) return; // Prevent empty messages

    setLoading(true); // Disable button immediately

    const formData = new FormData();
    formData.append("project_id", value?.id);
    formData.append("emp_id", user?.user_id);
    formData.append("remarks", text);
    formData.append("name", user?.full_name);
    formData.append("media_type", !file ? "0" : isImage(file) ? "0" : "1");
    formData.append("todo_id", "");

    if (file) {
      formData.append("file", file, file?.name);
    }

    try {
      const response = await ProjectDiscussionCreate(formData);
      if (response.status) {
        console.log("Successfully sent message:", response);
      } else {
        console.error("Failed to send message:", response.message);
      }
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setFile(null); // Clear file input
      setText(""); // Clear text field
      fetchProjectDiscussion(); // Refresh discussions
      setLoading(false); // Re-enable button
    }
  };

  function getCurrentDate() {
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const start_time = now.toTimeString().split(" ")[0];
    return { date, start_time };
  }

  const onHandleStartStopTimer = async (con, Item) => {
    try {
      showLoader();
      var current = getCurrentDate();
      var payload = {
        emp_id: user?.user_id,
        project_id: Item?.ProjectID || "",
        task_id: Item?.id,
        hour_rate: Item?.hourly_rate || 0,
        date: current.date,
        start_time: current.start_time,
        status: con ? "False" : "True",
      };
      const res = await CreateTaskTrack(payload);
      if (res.data) {
        await fetchTodo();
        hideLoader();
      }
      hideLoader();
    } catch (err) {
      hideLoader();
      console.log(err);
    } finally {
      hideLoader();
    }
  };

  const openDeleteModel = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  };

  const handleDelete = async () => {
    try {
      await Deletebuget(deleteID);
      toast.success("Document deleted successfully");
      fetchBudgets();
      showDeletemodel(false);
    } catch (error) {
      console.error("Error deleting Document table:", error);
    }
  };

  const expensehandleDelete = async (id) => {
    if (!id) {
      toast.error("Invalid expense ID");
      return;
    }

    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this expense?"
      );
      if (!confirmDelete) return;

      await DeleteTaskExpense(id);
      toast.success("Expense deleted successfully");
      fetchTasks();
      showDeletemodel(false);
    } catch (error) {
      toast.error("Failed to delete expense");
      console.error("Error deleting expense:", error);
    }
  };

  const handleDeleteModal = async (id) => {
    if (!id) {
      toast.error("Invalid expense ID");
      return;
    }

    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this Task?"
      );
      if (!confirmDelete) return;

      await deleteTodo(id);
      toast.success("Task deleted successfully");
      await fetchTodo();
      showDeletemodel(false);
    } catch (error) {
      toast.error("Failed to delete Task");
      console.error("Error deleting Task:", error);
    }
  };

  useEffect(() => {
    fetchProjectDetail(value?.id);
  }, [selectedtab == 0]);

  return (
    <div style={{ padding: "0px 20px 20px 20px" }}>
      <div className="p-4 bg-white">
        <div className="">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <div className="d-flex flex-wrap gap-3 justify-content-center text-small justify-content-md-start w-95">
              <p
                style={{
                  color: selectedtab === 0 ? "blue" : "black",
                  borderBottom: selectedtab === 0 ? "2px solid blue" : "",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedtab(0)}
              >
                Overview
              </p>
              <p
                style={{
                  color: selectedtab === 1 ? "blue" : "black",
                  borderBottom: selectedtab === 1 ? "2px solid blue" : "",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedtab(1)}
              >
                Task
              </p>
              <p
                style={{
                  color: selectedtab === 2 ? "blue" : "black",
                  borderBottom: selectedtab === 2 ? "2px solid blue" : "",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedtab(2)}
              >
                Timesheet
              </p>
              <p
                style={{
                  color: selectedtab === 3 ? "blue" : "black",
                  borderBottom: selectedtab === 3 ? "2px solid blue" : "",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedtab(3)}
              >
                Message Board
              </p>
              {/* <p
                style={{
                  color: selectedtab === 4 ? "blue" : "black",
                  borderBottom: selectedtab === 4 ? "2px solid blue" : "",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedtab(4)}
              >
                Expenses
              </p> */}
              <p
                style={{
                  color: selectedtab === 6 ? "blue" : "black",
                  borderBottom: selectedtab === 6 ? "2px solid blue" : "",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedtab(6)}
              >
                Budget
              </p>
              <p
                style={{
                  color: selectedtab === 5 ? "blue" : "black",
                  borderBottom: selectedtab === 5 ? "2px solid blue" : "",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedtab(5)}
              >
                Transaction
              </p>
            </div>
          </div>
        </div>

        {selectedtab == 0 ? (
          <div className="max-w-7xl mx-auto ">
            {/* Header Section */}
            <div className="card p-4  shadow p-3 bg-white rounded d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-3">
              {/* Left Section (Progress + Details) */}
              <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100">
                {/* Circular Progress Bar */}
                <div
                  className="relative mx-md-4 mx-auto mb-3 mb-md-0"
                  style={{ width: "90px" }}
                >
                  <CircularProgressbar
                    value={percentage}
                    text={`${percentage}%`}
                    styles={buildStyles({
                      textSize: "15px",
                      pathColor: "#9333ea",
                      textColor: "#9333ea",
                      trailColor: "#e5e7eb",
                    })}
                  />
                </div>

                {/* Project Details */}
                <div className="w-100">
                  <h1 className="d-flex align-items-center flex-wrap text-normal">
                    {projectData?.title} |
                    <span className="ms-2 px-2 py-1 rounded-pill bg-primary-subtle btn-small text-primary text-small">
                      {projectData?.status === "0" ? "Pending" : "Completed"}
                    </span>
                  </h1>

                  {/* Details Section */}
                  <div className="d-flex flex-wrap gap-3 py-1">
                    <p className="text-gray opacity-75 text-small me-3">
                      Start Date: <br />
                      <span
                        className="text- fw-bold text-small my-1"
                        style={{ color: "rgb(5, 48, 141)" }}
                      >
                        {projectData?.start_date}
                      </span>
                    </p>
                    <p className="text-gray opacity-75 text-small me-3">
                      End Date: <br />
                      <span
                        className="text- fw-bold text-small "
                        style={{ color: "rgb(5, 48, 141)" }}
                      >
                        {projectData?.end_date}
                      </span>
                    </p>
                    <p className="text-gray opacity-75 text-small me-3">
                      Client: <br />
                      <span
                        className="text- fw-bold text-small"
                        style={{ color: "rgb(5, 48, 141)" }}
                      >
                        {projectData?.client_name}
                      </span>
                    </p>
                    <div className="bg-gray-100 rounded-lg shadow-md text-small w-fit">
                      <p className="font-medium m-0 text-gray-800 text-sm">
                        Client Estimation
                      </p>
                      <div
                        className="text-xl fw-bold text-blue-900 flex items-center space-x-2"
                        style={{ color: "rgb(5, 48, 141)" }}
                      >
                        <span className="text-green-600">
                          {projectData?.paid_amount || 0}
                        </span>
                        <span className="text-gray-500">/</span>
                        <span>{projectData?.estimation_amount || 0}</span>
                      </div>
                    </div>
                    <div className="bg-gray-100 rounded-lg shadow-md text-small w-fit">
                      <p className="font-medium m-0 text-gray-800 text-sm">
                        Remaining Hours :
                      </p>
                      <div
                        className="text-xl fw-bold text-blue-900 flex items-center space-x-2"
                        style={{ color: "rgb(5, 48, 141)" }}
                      >
                        <span className="text-green-600">
                          {projectData?.total_hours - projectData?.total_sum_hours}
                        </span>
                      </div>
                    </div>
                    <p className="text-gray opacity-95 text-small me-4">
                      Team Member: <br />
                      <span className="d-inline-flex align-items-center">
                        {Array.from(
                          { length: Math.min(projectData?.project_type, 3) },
                          (_, index) => (
                            <span key={index} className="position-relative">
                              <img
                                src="./../assets/images/profile.png"
                                alt="Profile Icon"
                                className="rounded-circle"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  objectFit: "cover",
                                  cursor: "pointer",
                                  marginLeft: index === 0 ? "0px" : "-5px", // Overlapping effect
                                  border: "2px solid white", // For better visibility
                                }}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={`Member ${index + 1}`} // Tooltip shows member number
                              />
                            </span>
                          )
                        )}

                        {/* If more than 3 members, show +X */}
                        {projectData?.project_type > 3 && (
                          <span
                            className="rounded-circle d-flex align-items-center justify-content-center "
                            style={{
                              width: "20px",
                              height: "20px",
                              backgroundColor: "#ddd",
                              color: "rgb(5, 48, 141)",
                              fontSize: "12px",
                              fontWeight: "bold",
                              marginLeft: "-3px",
                              border: "2px solid white",
                              cursor: "pointer",
                            }}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={`+${projectData?.project_type - 3} more`} // Tooltip shows extra count
                          >
                            +{projectData?.project_type - 3}
                          </span>
                        )}
                      </span>
                    </p>

                    <p className="text-gray opacity-75 text-small me-3">
                      Create Time: <br />
                      <span
                        className="text- fw-bold text-small"
                        style={{ color: "rgb(5, 48, 141)" }}
                      >
                        -
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Edit Button (Floats Right) */}
              <div className="mt-3 mt-md-0">
                <img
                  src="/assets/images/icons/edit.png"
                  className="mx-3"
                  onClick={() => setShowModal(true)}
                  height={"25px"}
                  alt="edit"
                />
              </div>
            </div>

            {/* Project Description */}
            <div className="row mt-4">
              {/* Project Description */}
              <div className="col-12 col-md-6 d-flex mb-3 mb-md-0">
                <div className="card p-3 shadow  bg-white rounded w-100">
                  <h5
                    className="text-normal "
                    style={{ color: `rgb(3, 27, 78)`, fontSize: "14px" }}
                  >
                    PROJECT DESCRIPTION
                  </h5>
                  <p className="text-gray-500 text-normal">
                    {projectData?.description}
                  </p>
                </div>
              </div>

              {/* Budget Overview */}
              <div className="col-12 col-md-6 d-flex">
                <div className="card p-3 shadow  bg-white rounded w-100">
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                    <h5
                      className="text-normal "
                      style={{ color: `rgb(3, 27, 78)`, fontSize: "14px" }}
                    >
                      BUDGET OVERVIEW
                    </h5>
                    <p
                      className="fw-semibold text-small"
                      style={{ color: "rgb(3, 27, 78)" }}
                    >
                      Invested Cost:{" "}
                      <span className="fw-semibold">
                        {projectData?.total_cost}
                      </span>
                    </p>
                  </div>

                  {/* Responsive Table */}
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover table-sm whitespace-nowrap min-w-full mb-0">
                      <thead className="table-primary ">
                        <tr>
                          <th className="py-2 text-small px-3">TASKS</th>
                          <th className="py-2 text-small px-3">HOURS</th>
                          <th className="py-2 text-small px-3">COST</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            className="py-2 text-small px-3"
                            style={{
                              color: "rgb(3, 27, 78)",
                              fontSize: "12px",
                            }}
                          >
                            {value?.title}
                          </td>
                          <td
                            className="py-2 text-small fw-semibold px-3"
                            style={{
                              color: "rgb(3, 27, 78)",
                              fontSize: "12px",
                            }}
                          >
                            {value?.total_hours}
                          </td>
                          <td
                            className="py-2 text-small fw-semibold px-3"
                            style={{
                              color: "rgb(3, 27, 78)",
                              fontSize: "12px",
                            }}
                          >
                            {value?.hourly_rate}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Tasks Status and Tasks Worked */}
            <div className="row">
              {/* Tasks Status */}
              <div className=" col-12 col-md-6 d-flex mb-3 mb-md-0 shadow-md">
                <div className="card p-3 shadow  bg-white rounded w-100">
                  <h5
                    className="text-normal "
                    style={{ color: `rgb(3, 27, 78)`, fontSize: "14px" }}
                  >
                    TASKS STATUS
                  </h5>
                  <div className="position-relative d-flex justify-content-center mt-2">
                    <div style={{ width: "280px", height: "280px" }}>
                      <Pie data={chartData} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Tasks Worked */}
              <div className="col-12 col-md-6 d-flex">
                <div className="card p-3 shadow  bg-white rounded w-100">
                  <h5
                    className="text-normal "
                    style={{ color: `rgb(3, 27, 78)`, fontSize: "14px" }}
                  >
                    TASKS WORKED
                  </h5>
                  <table className="table table-bordered table-hover table-sm whitespace-nowrap min-w-full mb-0 ">
                    <thead className="table-primary">
                      <tr>
                        {/* <th className="py-2 text-small px-3">S.NO</th> */}
                        <th className="py-2 text-small px-3">TASKS</th>
                        <th className="py-2 text-small px-3">DUE DATE</th>
                        <th className="py-2 text-small px-3">TOTAL HOURS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {todo
                        // .filter((data) => data?.project_id == projectData?.id)
                        .map((item, index) => (
                          <tr
                            className="border-b border-primary/10"
                            key={index}
                            style={{ borderLeft: "1px solid green" }}
                            role="button"
                          >
                            <th
                              scope="col"
                              className={
                                "text-center text-secondary project-task"
                              }
                              style={{
                                verticalAlign: "middle",
                                borderLeft: "1px solid green",
                              }}
                            >
                              {item.title}
                            </th>
                            <th
                              scope="col"
                              className={"text-center text-secondary"}
                              style={{ verticalAlign: "middle" }}
                            >
                              {item?.to_date_time?.split("T")[0]}
                            </th>
                            <th
                              scope="col"
                              className={"text-center text-secondary"}
                              style={{ verticalAlign: "middle" }}
                            >
                              <span className="ms-3">{item?.total_hours}</span>
                            </th>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : selectedtab == 1 ? (
          <div className="" style={{ height: "80vh" }}>
            <div>
              <div className="mt-2 card p-3">
                {/* Header Section */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span style={{ fontSize: "18px", color: `rgb(3, 27, 78)` }}>
                    Tasks List
                  </span>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm text-small"
                    onClick={() => {
                      setSelectedTask();
                      setShowTaskModal(true);
                    }}
                  >
                    Add Task
                  </button>
                </div>

                <div
                  className="card p-0"
                  style={{ borderRadius: "0px", border: "none" }}
                >
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover table-sm whitespace-nowrap min-w-full mb-0">
                      <thead className="table-primary">
                        <tr>
                          <th
                            scope="col"
                            className="text-small"
                            style={{ width: "50%" }}
                          >
                            Tasks
                          </th>
                          <th scope="col" className="text-small">
                            Due Date
                          </th>
                          <th scope="col" className="text-small">
                            Assigned To
                          </th>
                          <th scope="col" className="text-small">
                            Status
                          </th>
                          <th scope="col" className="text-small">
                            Total Hours
                          </th>
                          <th scope="col" className="text-small">
                            Timer
                          </th>
                          <th scope="col" className="text-small">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {todo
                          // .filter((data) => data?.project_id == projectData?.id)
                          .map((item, index) => (
                            <tr
                              className="border-b border-primary/10"
                              key={index}
                              style={{ borderLeft: "1px solid green" }}
                              role="button"
                            >
                              <th
                                scope="col"
                                className={
                                  "text-center text-secondary project-task"
                                }
                                style={{
                                  verticalAlign: "middle",
                                  borderLeft: "1px solid green",
                                }}
                              >
                                {item.title}
                              </th>
                              <th
                                scope="col"
                                className={"text-center text-secondary"}
                                style={{ verticalAlign: "middle" }}
                              >
                                {item?.to_date_time?.split("T")[0]}
                              </th>
                              <th
                                scope="col"
                                className={"text-center text-secondary"}
                                style={{ verticalAlign: "middle" }}
                              >
                                <span
                                  className={`avatar-list-stacked flex -space-x-2 ms-1 float-left ml-5`}
                                >
                                  {item.employees
                                    ?.slice(0, 3)
                                    .map((idata, index) => (
                                      <img
                                        key={index}
                                        src="./../assets/images/profile.png"
                                        alt="Profile Icon"
                                        className="rounded-circle ms-2"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          objectFit: "cover",
                                          cursor: "pointer",
                                        }}
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title={idata.name.trim()}
                                      />
                                    ))}
                                </span>
                              </th>
                              <th
                                scope="col"
                                className={"text-center text-secondary"}
                                style={{ verticalAlign: "middle" }}
                              >
                                <span>
                                  <select
                                    value={item.status}
                                    onChange={(e) => {
                                      updateTodoStatus(item.id, e.target.value);
                                    }}
                                    className="dropdown-content"
                                    style={{
                                      backgroundColor: getBackgroundColor(
                                        item.status
                                      ),
                                    }}
                                  >
                                    {PROJECT_STATUS.map((status) => (
                                      <option
                                        value={status.id}
                                        className="ms-3"
                                      >
                                        {status.label}
                                      </option>
                                    ))}
                                  </select>
                                </span>
                              </th>
                              <th
                                scope="col"
                                className={"text-center text-secondary"}
                                style={{ verticalAlign: "middle" }}
                              >
                                <span className="ms-3">
                                  {item?.total_hours}
                                </span>
                              </th>
                              <th
                                scope="col"
                                className={"text-center text-secondary"}
                                style={{ verticalAlign: "middle" }}
                              >
                                <span className="ms-3">
                                  {item?.task_status == "True"
                                    ? "Running"
                                    : "Hold"}
                                </span>
                              </th>
                              <th className="py-2">
                                <div className="hstack flex gap-3 text-[.9375rem]">
                                  <div className="d-flex justify-content-center align-items-center">
                                    <button
                                      className="btn btn-primary mx-1 p-1 px-2 rounded-full"
                                      onClick={() => {
                                        // setSelectItem({ ...item, status: item?.task_status })
                                        onHandleStartStopTimer(
                                          item?.task_status == "True"
                                            ? true
                                            : false,
                                          item
                                        );
                                      }}
                                    >
                                      {item?.task_status == "True" ? (
                                        <img
                                          src="assets\icons\pause.png"
                                          width={"15px"}
                                          height={"15px"}
                                        />
                                      ) : (
                                        <img
                                          src="assets\icons\play.png"
                                          width={"15px"}
                                          height={"15px"}
                                        />
                                      )}
                                    </button>
                                  </div>

                                  <img
                                    src="/assets/images/icons/delete.png"
                                    className="mx-1"
                                    onClick={() => handleDeleteModal(item.id)}
                                    height={"15px"}
                                    alt="Delete"
                                  />

                                  <img
                                    src="/assets/images/icons/edit.png"
                                    className="mx-1"
                                    onClick={() => {
                                      setSelectedTask(item);
                                      setShowTaskModal(true);
                                    }}
                                    height={"15px"}
                                    alt="edit"
                                  />
                                  <img
                                    src="/assets/images/icons/shift-icon.png"
                                    className="mx-1"
                                    onClick={() => {
                                      handleOpenTimeModal(item);
                                    }}
                                    height={"15px"}
                                    alt="time"
                                  />
                                </div>
                              </th>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {showTimeModal && (
                  <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-md modal-dialog-centered">
                      <div className="modal-content p-3">
                        <div className="modal-header">
                          <h5 className="modal-title">Add Tasktime</h5>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Date</label>
                          <input
                            type="date"
                            className="form-control"
                            name="date"
                            value={selectedTask?.date || ""}
                            readOnly
                          />
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Start Time</label>
                            <input
                              type="time"
                              className="form-control"
                              name="start_time"
                              value={start_time}
                              onChange={(e) => setStartTime(e.target.value)}
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label">End Time</label>
                            <input
                              type="time"
                              className="form-control"
                              name="end_time"
                              value={end_time}
                              onChange={(e) => setEndTime(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="modal-footer">
                          <button className="btn btn-secondary" onClick={handleClearTime}>
                            Cancel
                          </button>
                          <button className="btn btn-success" onClick={handleSubmitTime}>
                            Add
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}


                {/* Task Table */}
                <div className="table-responsive d-none">
                  <table className="table table-bordered table-hover table-sm whitespace-nowrap min-w-full mb-0">
                    <thead className="table-primary">
                      <tr>
                        <th className="text-small" scope="col">
                          Task
                        </th>
                        <th className="text-small" scope="col">
                          Due Date
                        </th>
                        <th className="text-small" scope="col">
                          Assigned To
                        </th>
                        <th className="text-small" scope="col">
                          Total hours
                        </th>
                        <th className="text-small" scope="col">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {todo
                        .filter((data) => data?.project_id == projectData?.id)
                        .map((todos) => (
                          <tr key={todos.id}>
                            <td className="text-small">{todos.title}</td>
                            <td className="text-small">
                              {todos.from_date_time}
                            </td>
                            <td className="text-small">
                              {todos?.emp_id?.split(",").map((id, index) => (
                                <img
                                  key={index}
                                  src="./../assets/images/profile.png"
                                  alt="Profile Icon"
                                  className="rounded-circle ms-2"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    objectFit: "cover",
                                    cursor: "pointer",
                                  }}
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={id.trim()} // Shows emp_id as tooltip
                                />
                              ))}
                            </td>

                            <td className="text-small">
                              {todos.estimated_hours}
                            </td>
                            <td>
                              <span
                                className={`badge {todos.status === "active"
                                  ? "bg-success"
                                  : "bg-warning"
                                  }`}
                              >
                                {todos.status}
                              </span>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : selectedtab == 2 ? (
          <div className="" style={{ height: "80vh" }}>
            <div>
              <div className="mt-2 card p-3">
                {/* Header Section */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span style={{ fontSize: "18px", color: `rgb(3, 27, 78)` }}>
                    Timesheet
                  </span>
                </div>

                {/* Timesheet Table */}
                <div className="table-responsive">
                  <table className="table table-bordered table-hover table-sm whitespace-nowrap min-w-full mb-0">
                    <thead className="table-primary ">
                      <tr className="text-small">
                        <th className="text-small" scope="col">
                          Task
                        </th>
                        <th className="text-small" scope="col">
                          Date
                        </th>
                        <th className="text-small" scope="col">
                          Hours
                        </th>
                        <th className="text-small" scope="col">
                          Time
                        </th>
                        <th className="text-small" scope="col">
                          Status
                        </th>
                        {/* <th className="text-small" scope="col">
                          Action
                        </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-small">Develop Login Module</td>
                        <td className="text-small">2025-02-22</td>
                        <td className="text-small">4</td>
                        <td className="text-small">10:00 AM - 2:00 PM</td>
                        <td>
                          <span className="badge bg-success">Completed</span>
                        </td>
                        {/* <td>
                          <img
                            src="/assets/images/icons/delete.png"
                            className="mx-1"
                            // onClick={() => handleDeleteModal(Project.id)}
                            height={"20px"}
                            alt="Delete"
                          />
                          <img
                            src="/assets/images/icons/edit.png"
                            className="mx-1"
                            // onClick={() => handleProjectview(Project)}
                            height={"20px"}
                            alt="edit"
                          />
                          <img
                            src="/assets/images/icons/view.png"
                            className="mx-1"
                            // onClick={() => handleView(Project)}
                            height={"20px"}
                            alt="Delete"
                          />
                        </td> */}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : selectedtab == 3 ? (
          <div className=" py-2 px-1">
            <div className="row justify-content-center">
              <div className="col-lg-12 col-md-10 col-sm-12">
                <div className="p-1">
                  <div className="mt-1 p-1">
                    <span
                      className="mx-3"
                      style={{ fontSize: "18px", color: "rgb(3, 27, 78)" }}
                    >
                      Comment :
                    </span>

                    {/* Comment Input Section */}
                    <div className="p-3 ">
                      <div className="card p-3 mt-0">
                        <div className="d-flex align-items-center gap-2">
                          {file && (
                            <div className="mt-0 p-2 mb-2 border rounded bg-light">
                              {file.type.startsWith("image/") ? (
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt="Preview"
                                  className="img-thumbnail"
                                  style={{ maxWidth: "100px" }}
                                />
                              ) : (
                                <span>{file.name}</span>
                              )}
                            </div>
                          )}
                          <textarea
                            className="form-control mb-2"
                            rows="3"
                            placeholder="Write a comment..."
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                          ></textarea>
                        </div>
                        {/* File Upload */}
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <label
                              htmlFor="image-upload"
                              className="btn btn-outline-secondary btn-sm"
                            >
                              <i className="ri-upload-line me-1"></i> Upload
                              File
                            </label>
                            <input
                              type="file"
                              id="image-upload"
                              accept="image/*,.pdf,.doc,.docx,.txt,.zip"
                              hidden
                              onChange={handleFileChange}
                            />
                          </div>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={handleSend}
                            disabled={loading || (!text && !file)}
                          >
                            {loading ? "Sending..." : "Send"}
                          </button>
                        </div>
                      </div>

                      {/* Show Image Preview with Caption */}
                      {false && (
                        <div className="mt-2 p-2 border rounded bg-light">
                          {file.type.startsWith("image/") ? (
                            <img
                              src={URL.createObjectURL(file)}
                              alt="Preview"
                              className="img-thumbnail"
                              style={{ maxWidth: "100px" }}
                            />
                          ) : (
                            <span>{file.name}</span>
                          )}
                          <input
                            type="text"
                            className="form-control mt-1"
                            placeholder="Enter caption (optional)..."
                            value={caption}
                            onChange={(e) => setCaption(e.target.value)}
                          />
                        </div>
                      )}

                      {/* Scrollable Messages List */}
                      <div
                        className="comment-list mt-2"
                        style={{
                          maxHeight: "400px",
                          overflowY: "auto",
                          paddingRight: "5px",
                        }}
                      >
                        <span
                          className=""
                          style={{ fontSize: "16px", color: "rgb(3, 27, 78)" }}
                        >
                          Messages:
                        </span>

                        <div className="comment-list mt-4">
                          {messages.length > 0 &&
                            messages.map((comment) => (
                              <div
                                key={comment.id}
                                className="comment-item d-flex align-items-start flex-wrap"
                              >
                                <div className="avatar-section">
                                  <img
                                    src={comment.avatarUrl}
                                    alt={`${comment.username}'s avatar`}
                                    className="comment-avatar"
                                    onError={handleUserImageError}
                                  />
                                </div>
                                <div className="content-section mx-2">
                                  <div className="user-info">
                                    <span className="username">
                                      {comment.username}
                                    </span>
                                  </div>
                                  <div
                                    className="comment-date text-small"
                                    style={{ color: "rgb(3, 27, 78)" }}
                                  >
                                    {comment.date}
                                  </div>
                                  <div className="comment-text">
                                    <p>{comment.comment}</p>
                                    {comment.image && (
                                      <img
                                        src={comment.image}
                                        style={{
                                          width: "fit-content",
                                          maxWidth: "150px",
                                        }}
                                        onError={handleImageError}
                                      />
                                    )}
                                    {comment.link && (
                                      <a
                                        href={comment.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {comment.link}
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>

                        {false &&
                          messages.map((msg) => (
                            <div
                              key={msg.id}
                              className="d-flex align-items-start p-2 border rounded mb-2 bg-light shadow-sm"
                              style={{ fontSize: "14px", minHeight: "50px" }}
                            >
                              {/* Avatar */}
                              <img
                                src={
                                  user.image
                                    ? `${MediaUrl + user.image}`
                                    : "./../assets/images/profile.png"
                                }
                                alt="User Avatar"
                                className="rounded-circle me-2"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  objectFit: "cover",
                                }}
                              />

                              <div style={{ width: "120%", flexGrow: 1 }}>
                                {/* Name & Time in the Same Line */}
                                <div className="d-flex justify-content-between">
                                  <span
                                    className="fw-bold text-primary"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {msg.employee_name}
                                  </span>
                                  <small
                                    className="text-muted"
                                    style={{ fontSize: "10px" }}
                                  >
                                    {msg.time}
                                  </small>
                                </div>

                                {/* Message Text */}
                                {msg.remarks && (
                                  <p
                                    className="mt-1 mb-0"
                                    style={{
                                      fontSize: "12px",
                                      color: "rgb(3, 27, 78)",
                                    }}
                                  >
                                    {msg.remarks}
                                  </p>
                                )}

                                {/* Display Image with Caption */}
                                {msg.file &&
                                  msg.file.type.startsWith("image/") && (
                                    <div className="mt-1">
                                      <img
                                        src={URL.createObjectURL(msg.file)}
                                        alt="User Upload"
                                        className="img-thumbnail"
                                        style={{
                                          maxWidth: "50px",
                                          maxHeight: "50px",
                                        }}
                                      />
                                    </div>
                                  )}

                                {/* Display Non-Image Files */}
                                {msg.file &&
                                  !msg.file.type.startsWith("image/") && (
                                    <div className="mt-1">
                                      <a
                                        href={URL.createObjectURL(msg.file)}
                                        download
                                        className="text-primary"
                                      >
                                        {msg.file.name}
                                      </a>
                                    </div>
                                  )}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : selectedtab == 'false' ? (
          <div className="" style={{ height: "80vh" }}>
            <div className="card p-3 mt-2">
              <button
                className="btn btn-primary mb-3 text-small"
                onClick={() => setShow(true)}
                style={{ width: "150px" }}
              >
                Add Expense
              </button>

              {/* Modal */}
              {show && (
                <div className="modal fade show d-block" tabIndex="-1">
                  <div className="modal-dialog modal-md modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        {/* <h5 className="modal-title">Add Expense</h5> */}
                        <h5 className="modal-title">
                          {editExpense ? "Edit Expense" : "Add Expense"}
                        </h5>

                        <button
                          className="btn-close"
                          onClick={() => handleClear()}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="mb-3">
                            <label className="form-label">Title</label>
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              value={formData.title}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Description</label>
                            <textarea
                              className="form-control"
                              name="description"
                              value={formData.description}
                              onChange={handleChange}
                            ></textarea>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Amount</label>
                            <input
                              type="number"
                              className="form-control"
                              name="amount"
                              value={formData.amount}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              Upload Invoice Image
                            </label>
                            <input
                              type="file"
                              className="form-control"
                              name="media_urls"
                              accept=".png, .jpg, .jpeg, .pdf"
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </form>
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn btn-secondary"
                          onClick={() => handleClear()}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-success"
                          onClick={handleSubmit}
                        >
                          {editExpense ? "Update " : "Add "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Table to display expenses */}
              <div className="table-responsive">
                <table className="table table-bordered table-hover table-sm whitespace-nowrap min-w-full mb-0">
                  <thead className="table-primary">
                    <tr>
                      <th className="text-small">#</th>
                      <th className="text-small">Title</th>
                      <th className="text-small">Description</th>
                      <th className="text-small">Amount</th>
                      <th className="text-small">Invoice Image</th>
                      <th className="text-small">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listdata.length > 0 ? (
                      listdata.map((task, index) => (
                        <tr key={task.id}>
                          <td className="text-small">{index + 1}</td>
                          <td className="text-small">{task.title}</td>
                          <td className="text-small">{task.description}</td>
                          <td className="text-small">{task.amount}</td>
                          <td>
                            {task.media_urls ? (
                              <img
                                src={`${apiClient.defaults.baseURL}${task.media_urls}`} // Construct full URL
                                alt="Invoice"
                                width="30"
                                height="30"
                              />
                            ) : (
                              "No Image"
                            )}
                          </td>
                          <td>
                            <img
                              src="/assets/images/icons/edit.png"
                              className="mx-1"
                              onClick={() => ExpeseshandleEdit(task)}
                              height={"16px"}
                            />
                            <img
                              src="/assets/images/icons/delete.png"
                              className="mx-1"
                              onClick={() => expensehandleDelete(task.id)}
                              height={"16px"}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No tasks found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : selectedtab == 5 ? (
          <>
            <div className="card shadow p-3 bg-white rounded d-flex mb-3" style={{ height: "80vh" }}>
              <div className="d-flex flex-wrap gap-3 justify-content-center text-small justify-content-md-start w-95">
                <p
                  style={{
                    color: transtab === 0 ? "blue" : "black",
                    borderBottom: transtab === 0 ? "2px solid blue" : "",
                    cursor: "pointer",
                  }}
                  onClick={() => setTranstab(0)}
                >
                  Expense
                </p>
                <p
                  style={{
                    color: transtab === 1 ? "blue" : "black",
                    borderBottom: transtab === 1 ? "2px solid blue" : "",
                    cursor: "pointer",
                  }}
                  onClick={() => setTranstab(1)}
                >
                  Invoice
                </p>
              </div>

              {transtab == 0 &&
                <div className="">
                  <div className="w-100 d-flex justify-content-end">
                    <button
                      className="btn btn-primary mb-3 text-small"
                      onClick={() => setShow(true)}
                      style={{ width: "150px" }}
                    >
                      Add Expense
                    </button>
                  </div>

                  {/* Modal */}
                  {show && (
                    <div className="modal fade show d-block" tabIndex="-1">
                      <div className="modal-dialog modal-md modal-dialog-centered">
                        <div className="modal-content">
                          <div className="modal-header">
                            {/* <h5 className="modal-title">Add Expense</h5> */}
                            <h5 className="modal-title">
                              {editExpense ? "Edit Expense" : "Add Expense"}
                            </h5>

                            <button
                              className="btn-close"
                              onClick={() => handleClear()}
                            ></button>
                          </div>
                          <div className="modal-body">
                            <form>
                              <div className="mb-3">
                                <label className="form-label">Title</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="title"
                                  value={formData.title}
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label">Description</label>
                                <textarea
                                  className="form-control"
                                  name="description"
                                  value={formData.description}
                                  onChange={handleChange}
                                ></textarea>
                              </div>
                              <div className="mb-3">
                                <label className="form-label">Amount</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="amount"
                                  value={formData.amount}
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                              <div className="mb-3">
                                <label className="form-label">
                                  Upload Invoice Image
                                </label>
                                <input
                                  type="file"
                                  className="form-control"
                                  name="media_urls"
                                  accept=".png, .jpg, .jpeg, .pdf"
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                            </form>
                          </div>
                          <div className="modal-footer">
                            <button
                              className="btn btn-secondary"
                              onClick={() => handleClear()}
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-success"
                              onClick={handleSubmit}
                            >
                              {editExpense ? "Update " : "Add "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Table to display expenses */}
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover table-sm whitespace-nowrap min-w-full mb-0">
                      <thead className="table-primary">
                        <tr>
                          <th className="text-small">#</th>
                          <th className="text-small">Title</th>
                          <th className="text-small">Description</th>
                          <th className="text-small">Amount</th>
                          <th className="text-small">Invoice Image</th>
                          <th className="text-small">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listdata.length > 0 ? (
                          listdata.map((task, index) => (
                            <tr key={task.id}>
                              <td className="text-small">{index + 1}</td>
                              <td className="text-small">{task.title}</td>
                              <td className="text-small">{task.description}</td>
                              <td className="text-small">{task.amount}</td>
                              <td>
                                {task.media_urls ? (
                                  <img
                                    src={`${apiClient.defaults.baseURL}${task.media_urls}`} // Construct full URL
                                    alt="Invoice"
                                    width="30"
                                    height="30"
                                  />
                                ) : (
                                  "No Image"
                                )}
                              </td>
                              <td>
                                <img
                                  src="/assets/images/icons/edit.png"
                                  className="mx-1"
                                  onClick={() => ExpeseshandleEdit(task)}
                                  height={"16px"}
                                />
                                <img
                                  src="/assets/images/icons/delete.png"
                                  className="mx-1"
                                  onClick={() => expensehandleDelete(task.id)}
                                  height={"16px"}
                                />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No tasks found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              }

              {transtab == 1 && <Transaction projectId={value?.id} />}
            </div>
          </>
        ) : (
          <div className="" style={{ height: "80vh" }}>
            <div className="card p-3 mt-2 ">
              <button
                className="btn btn-primary mb-3 text-small"
                onClick={() => setShow1(true)}
                style={{ width: "150px" }}
              >
                Add Budget
              </button>
              <>
                Total Budget :
                {budgetList.length > 0
                  ? budgetList.reduce(
                    (total, budget) => total + Number(budget.total_cost),
                    0
                  )
                  : 0}
              </>

              {/* Table to display budgets */}
              {show1 && (
                <div className="modal fade show d-block" tabIndex="-1">
                  <div className="modal-dialog modal-md modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          {editBudget ? "Edit Budget" : "Add Budget"}
                        </h5>
                        <button
                          className="btn-close"
                          onClick={handleClear1}
                        ></button>
                      </div>
                      <div className="modal-body p-4">
                        <form>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label className="form-label">Title</label>
                              <input
                                type="text"
                                className="form-control"
                                name="title"
                                value={budgetData.title}
                                onChange={handleChange1}
                              />
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">Date</label>
                              <input
                                type="date"
                                className="form-control"
                                name="date"
                                value={budgetData.date}
                                onChange={handleChange1}
                              />
                            </div>
                          </div>

                          <div className="mb-3">
                            <label className="form-label">Remark</label>
                            <textarea
                              className="form-control"
                              name="remark"
                              value={budgetData.remark}
                              onChange={handleChange1}
                            ></textarea>
                          </div>

                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label className="form-label">From Date</label>
                              <input
                                type="date"
                                className="form-control"
                                name="from_date"
                                value={budgetData.from_date}
                                onChange={handleChange1}
                                max={budgetData.to_date}
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="form-label">To Date</label>
                              <input
                                type="date"
                                className="form-control"
                                name="to_date"
                                value={budgetData.to_date}
                                min={budgetData.from_date}
                                onChange={handleChange1}
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="form-label">Total Cost</label>
                              <input
                                type="number"
                                className="form-control"
                                name="total_cost"
                                value={budgetData.total_cost}
                                onChange={handleChange1}
                              />
                            </div>

                            <div className="col-md-6 mb-3">
                              <label className="form-label">Total Hours</label>
                              <input
                                type="number"
                                className="form-control"
                                name="total_hours"
                                value={budgetData.total_hours}
                                onChange={handleChange1}
                              />
                            </div>
                          </div>
                        </form>
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn btn-secondary"
                          onClick={handleClear1}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-success"
                          onClick={handleSubmit1}
                        >
                          {editBudget ? "Update " : "Add "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="table-responsive">
                <table className="table table-responsive table-bordered table-hover table-sm whitespace-nowrap min-w-full mb-0">
                  <thead className="table-primary">
                    <tr>
                      <th className="text-small">#</th>
                      <th className="text-small">Title</th>
                      <th className="text-small">Date</th>
                      <th className="text-small">Remark</th>
                      <th className="text-small">From Date</th>
                      <th className="text-small">To Date</th>
                      <th className="text-small">Total Cost</th>
                      <th className="text-small">Total Hours</th>
                      <th className="text-small">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {budgetList.length > 0 ? (
                      budgetList.map((budget, index) => (
                        <tr key={budget.id || index}>
                          <td className="text-small">{index + 1}</td>
                          <td className="text-small">{budget.title}</td>
                          <td className="text-small">{budget.date}</td>
                          <td className="text-small">{budget.remark}</td>
                          <td className="text-small">{budget.from_date}</td>
                          <td className="text-small">{budget.to_date}</td>
                          <td className="text-small">{budget.total_cost}</td>
                          <td className="text-small">{budget.total_hours}</td>
                          <td>
                            <img
                              src="/assets/images/icons/edit.png"
                              className="mx-1"
                              onClick={() => handleEdit(budget)}
                              height={"16px"}
                            />

                            <img
                              src="/assets/images/icons/delete.png"
                              className="mx-1"
                              onClick={() => openDeleteModel(budget.id)}
                              height={"16px"}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No budgets found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {showModal && (
          <ProjectForm
            openModal={showModal}
            setOpenModal={setShowModal}
            unit={projectData}
            closeModal={() => setShowModal(false)}
            employeeData={employeeData}
            managerData={managerData}
            refreshList={fetchProjectDetail}
          />
        )}

        {deletemodel && (
          <Deletemodel
            setShowModal={showDeletemodel}
            handleDelete={handleDelete}
          />
        )}

        {showTaskModal && (
          <TaskFormProject
            openModal={showTaskModal}
            setOpenModal={setShowTaskModal}
            unit={selectedTask}
            closeModal={() => setShowTaskModal(false)}
            refreshList={fetchTodo}
            onSubmit={handleAddTask}
            employeeData={employeeData}
            project={projectData}
          />
        )}
      </div>
    </div>
  );
};

export default Projectview;
